<div class="field" [formGroup]="form" [class.error]="passwordError.hasError('*', 'touched')">
  <label for="password" translate>auth.login.password</label>
  <input type="password" formControlName="password" [placeholder]="'auth.login.password' | translate">
  <div class="box-error" ngxErrors="password" #passwordError="ngxErrors">
    <p class="error" ngxError="required" when="touched" translate>error.required</p>
    <p class="error" ngxError="email" when="touched" translate>error.email</p>
  </div>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/auth/login/login-form/login-password-field/login-password-field.component.html